export default {
  'aiBilling.title': 'AI Billing',

  'aiBilling.tabs.profile': 'Profile',
  'aiBilling.tabs.limits': 'Limits',
  'aiBilling.tabs.periods': 'Periods',
  'aiBilling.tabs.grants': 'Grants',

  'aiBilling.action.saveChanges': 'Save changes',
  'aiBilling.action.save': 'Save',

  'aiBilling.validation.required': 'This field is required.',
  'aiBilling.validation.invalidEmails': 'One or more emails have an invalid format.',
  'aiBilling.validation.negativeAmount': 'Amount cannot be negative.',

  'aiBilling.text.enabled': 'Enabled',
  'aiBilling.text.disabled': 'Disabled',
  'aiBilling.text.active': 'Active',
  'aiBilling.text.inactive': 'Inactive',

  'aiBilling.profile.billingMode': 'Billing mode',
  'aiBilling.profile.budgetEditMode': 'Budget edit mode',
  'aiBilling.profile.currency': 'Currency',
  'aiBilling.profile.isBudgetEnabled': 'Budget enabled',
  'aiBilling.profile.monthlyIncludedCreditOverrideAmount': 'Monthly included credit override',
  'aiBilling.profile.notifyMonthlyCreditGranted': 'Notify monthly credit granted',
  'aiBilling.profile.alertEmails': 'Alert emails',
  'aiBilling.profile.alertEmails.help': 'Separate multiple emails with semicolon (;).',
  'aiBilling.profile.monthlyBudgetAmount': 'Monthly budget amount',
  'aiBilling.profile.maxSelfServiceBudgetAmount': 'Max self-service budget amount',
  'aiBilling.profile.budgetExceededBehavior': 'Budget exceeded behavior',

  'aiBilling.billingMode.creditCard': 'Credit card',
  'aiBilling.billingMode.manualBilling': 'Manual billing',

  'aiBilling.budgetEditMode.selfService': 'Self-service',
  'aiBilling.budgetEditMode.requiresAutomyApproval': 'Requires Automy approval',
  'aiBilling.budgetEditMode.automyOnly': 'Automy only',

  'aiBilling.budgetExceededBehavior.blockUsage': 'Block usage',
  'aiBilling.budgetExceededBehavior.allowWithWarning': 'Allow with warning',

  'aiBilling.currency.usd': 'USD',

  'aiBilling.limits.monthlyBudget': 'Monthly budget',
  'aiBilling.limits.monthlyBudgetAmount': 'Monthly budget amount',
  'aiBilling.limits.alerts': 'Alerts',
  'aiBilling.limits.addAlert': 'Add alert',
  'aiBilling.limits.editAlert': 'Edit alert',
  'aiBilling.limits.sendToOrganizationOwners': 'Send to organization owners',
  'aiBilling.limits.budgetDisabled': 'Budget is disabled in profile. Enable budget to edit limits.',
  'aiBilling.limits.deleteConfirm.title': 'Delete alert',
  'aiBilling.limits.deleteConfirm.content': 'Do you want to delete this consumption alert?',

  'aiBilling.limits.columns.threshold': 'Threshold',
  'aiBilling.limits.fields.thresholdPercentage': 'Threshold (%)',
  'aiBilling.limits.columns.emailSubjectPrefix': 'Email subject prefix',
  'aiBilling.limits.columns.emails': 'Emails',
  'aiBilling.limits.columns.enabled': 'Status',

  'aiBilling.periods.filter.status': 'Filter by status',
  'aiBilling.periods.columns.period': 'Period',
  'aiBilling.periods.columns.status': 'Status',
  'aiBilling.periods.columns.budget': 'Consumed / budget',
  'aiBilling.periods.columns.credit': 'Credit consumed / granted',
  'aiBilling.periods.columns.billableAmount': 'Billable amount',
  'aiBilling.periods.columns.periodStart': 'Start',
  'aiBilling.periods.columns.periodEnd': 'End',

  'aiBilling.period.status.active': 'Active',
  'aiBilling.period.status.closed': 'Closed',
  'aiBilling.period.status.blocked': 'Blocked',

  'aiBilling.grants.columns.type': 'Type',
  'aiBilling.grants.columns.period': 'Period',
  'aiBilling.grants.columns.balance': 'Available / original',
  'aiBilling.grants.columns.originalAmount': 'Original amount',
  'aiBilling.grants.columns.remainingAmount': 'Remaining amount',
  'aiBilling.grants.columns.currency': 'Currency',
  'aiBilling.grants.columns.validFrom': 'Valid from',
  'aiBilling.grants.columns.expiresAt': 'Expires at',
  'aiBilling.grants.columns.isActive': 'Status',
  'aiBilling.grants.columns.reason': 'Reason',
  'aiBilling.grants.columns.creator': 'Creator',
  'aiBilling.grants.columns.created': 'Created',

  'aiBilling.grant.type.planIncludedMonthlyCredit': 'Plan included',
  'aiBilling.grant.type.promotionalCredit': 'Promotional',
  'aiBilling.grant.type.manualBonus': 'Manual bonus',
  'aiBilling.grant.type.supportCompensation': 'Support compensation',
  'aiBilling.grant.type.paidCredit': 'Top-up',
  'aiBilling.grant.type.adjustment': 'Adjustment',
};
